import React from 'react';
import { SchemaRenderer } from '@ui-engine/index';
import { type UISchema, type EvaluationContext } from '../../types';

interface ScreenProps {
  schema: UISchema;
  context?: EvaluationContext;
  onAction?: (actionId: string, payload?: any) => void;
}

export const Screen: React.FC<ScreenProps> = ({ schema, context = {}, onAction }) => {
  return (
    <div className="w-full h-full">
      <SchemaRenderer schema={schema} context={context} onAction={onAction} />
    </div>
  );
};
